import axios from 'axios';

axios.defaults.baseURL = "https://admin.fredoinvest.com/api/";
//axios.defaults.baseURL = "http://192.168.1.25/fredo-backend/public/api";
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';